<app-layout>
  <div class="row">
    <div class="col-12" *ngIf="lojistikFiyat">
      <div class="card">
        <div class="card-header">
          <h4 class="card-title">{{id === '0' ? 'Yeni Fiyat' : 'Fiyat Düzenle'}}</h4>
          <div class="card-options">
            <div class="btn btn-sm btn-pill btn-success" (click)="save()">
              Kaydet
            </div>
          </div>
        </div>
        <div class="card-body">
          <div class="row">
            <div class="col-md-12 col-lg-6">
              <div class="mb-3">
                <div class="form-label">Tarih</div>
                <input mwlFlatpickr class="form-control mb-2 flatpickr-input" type="text"
                  placeholder="Tarih" [altInput]="true" [convertModelValue]="true"
                  [(ngModel)]="lojistikFiyat.tarih">
              </div>
            </div>
            <div class="col-md-12 col-lg-6">
              <div class="mb-3">
                <div class="form-label">Fiyat</div>
                <input type="number" class="form-control" placeholder="Fiyat" [(ngModel)]="lojistikFiyat.fiyat">
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</app-layout>
